"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Description = function (_a) {
    var title = _a.title, description = _a.description;
    var conditions = description === null || description === void 0 ? void 0 : description.split('.').slice(0, -1);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description },
            react_1.default.createElement("ol", null, conditions && (conditions === null || conditions === void 0 ? void 0 : conditions.length) > 0
                ? conditions === null || conditions === void 0 ? void 0 : conditions.map(function (c, idx) { return (react_1.default.createElement("li", { key: "tournamentConditions".concat(idx) },
                    c,
                    ".")); })
                : description))));
};
exports.default = Description;
